import { useEffect } from 'react'

export function useWorkspaceThemePrompt(
    roomId: string | undefined,
    setcTheme: (t: string) => void,
    setPrompt: (b: boolean) => void
) {
    useEffect(() => {
        const savedColorTheme = localStorage.getItem("flashroom-color-theme");
        if (!savedColorTheme) {
            setPrompt(true);
        } else {
            setcTheme(savedColorTheme)
        }
    }, [roomId])

    const setColorClick = (ctheme: string) => {
        localStorage.setItem("flashroom-color-theme", ctheme);
        setcTheme(ctheme);
        setPrompt(false);
    }

    return { setColorClick };
}
